module.exports = __webpack_public_path__ + "static/media/illust_marketing_engage.cd96d4fa.png";